"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const calculations_1 = require("@munters/calculations");
const newRow = {
    temperature: property_1.PropertyValue.fromAmount(uom_1.Amount.create(20, uom_1.Units.Celsius)),
    humidity: property_1.PropertyValue.fromAmount(uom_1.Amount.create(10, uom_1.Units.GramPerKilogram)),
    enthalpy: property_1.PropertyValue.fromAmount(uom_1.Amount.create(45.5, uom_1.Units.KilojoulePerKilogram)),
    sensiblepower: property_1.PropertyValue.fromAmount(uom_1.Amount.create(0, uom_1.Units.KiloWatt)),
    totalpower: property_1.PropertyValue.fromAmount(uom_1.Amount.create(0, uom_1.Units.KiloWatt))
};
const initialState = {
    chartInputs: {
        pressure: property_1.PropertyValueSet.fromString("pressure=101325:Pascal"),
        rows: [],
        chartSettings: property_1.PropertyValueSet.fromString("showpower=0;charttype=0;ipsi=0")
    },
    chartState: {
        pressure: property_1.PropertyValueSet.fromString("pressure=101325:Pascal"),
        rows: [newRow],
        chartSettings: property_1.PropertyValueSet.fromString("showpower=0;charttype=0;ipsi=0")
    },
    airflow: property_1.PropertyValueSet.fromString("airflow=2990:StandardCubicMeterPerHour"),
    showChart: false,
    selectedCulture: undefined,
    showLoader: false
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "psychrometric-tool/ADD-ROW":
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { rows: [...state.chartState.rows, newRow] }) });
        case "psychrometric-tool/DELETE-ROW": {
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { rows: state.chartState.rows
                        .slice(0, action.payload.rowIndex)
                        .concat(state.chartState.rows.slice(action.payload.rowIndex + 1)) }) });
        }
        case "psychrometric-tool/SET-PROPERTIES-ROW": {
            const humidity = property_1.PropertyValueSet.getAmount("humidity", action.payload.pvs);
            const temperature = property_1.PropertyValueSet.getAmount("temperature", action.payload.pvs);
            const pressure = property_1.PropertyValueSet.getAmount("pressure", state.chartState.pressure);
            const enthalpy = calculations_1.Physics.RP1485.AmountConversions.humidityRatioToSpecificEnthalpy(pressure, temperature, humidity);
            const row = {
                humidity: property_1.PropertyValue.fromAmount(humidity),
                temperature: property_1.PropertyValue.fromAmount(temperature),
                enthalpy: property_1.PropertyValue.fromAmount(enthalpy)
            };
            const rows = state.chartState.rows.slice(0);
            rows.splice(action.payload.rowIndex, 1, row);
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { rows }) });
        }
        case "psychrometric-tool/SET-PROPERTIES-SHOW-POWER":
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { chartSettings: action.payload }) });
        case "psychrometric-tool/SET-PROPERTIES-AIR-FLOW":
            return Object.assign(Object.assign({}, state), { airflow: action.payload });
        case "psychrometric-tool/SET-PROPERTIES-PRESSURE":
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { pressure: action.payload }) });
        case "psychrometric-tool/SET-PROPERTIES-GENERATE":
            return Object.assign(Object.assign({}, state), { chartState: Object.assign(Object.assign({}, state.chartState), { rows: state.chartState.rows.map((row, rowIndex) => {
                        if (rowIndex === 0) {
                            return Object.assign(Object.assign({}, row), { sensiblepower: property_1.PropertyValue.fromAmount(uom_1.Amount.create(0, uom_1.Units.Watt)), totalpower: property_1.PropertyValue.fromAmount(uom_1.Amount.create(0, uom_1.Units.Watt)) });
                        }
                        const airIn = state.chartState.rows[rowIndex - 1];
                        const temperatureIn = property_1.PropertyValueSet.getAmount("temperature", airIn);
                        const humidityIn = property_1.PropertyValueSet.getAmount("humidity", airIn);
                        const temperatureOut = property_1.PropertyValueSet.getAmount("temperature", row);
                        const humidtyOut = property_1.PropertyValueSet.getAmount("humidity", row);
                        const pressure = property_1.PropertyValueSet.getAmount("pressure", state.chartState.pressure);
                        const flow = property_1.PropertyValueSet.getAmount("airflow", state.airflow);
                        return Object.assign(Object.assign({}, row), { sensiblepower: property_1.PropertyValue.fromAmount(calculations_1.Physics.AirCalculation.calculateAirSensiblePowerForAirFlowAirInAirOut(temperatureIn, humidityIn, pressure, temperatureOut, pressure, flow)), totalpower: property_1.PropertyValue.fromAmount(calculations_1.Physics.AirCalculation.calculateAirTotalPowerForAirFlowAirInAirOut(temperatureIn, humidityIn, pressure, temperatureOut, humidtyOut, pressure, flow)) });
                    }) }) });
        case "psychrometric-tool/SET-PROPERTIES-SHOW-CHART":
            return Object.assign(Object.assign({}, state), { showChart: true, chartInputs: Object.assign({}, state.chartState) });
        case "psychrometric-tool/SELECTED-CULTURE":
            return Object.assign(Object.assign({}, state), { selectedCulture: action.payload });
        case "psychrometric-tool/SHOW-LOADER":
            return Object.assign(Object.assign({}, state), { showLoader: true });
        case "psychrometric-tool/HIDE-LOADER":
            return Object.assign(Object.assign({}, state), { showLoader: false });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map